export default "__VITE_ASSET__C6gTDo1l__"